import { useEffect, useMemo, useState } from "react";
import { honeyJarsContract } from "config";
import { useContractRead } from "wagmi";
import { BigNumber } from "ethers";

const useFancyBearsInWallet = (
  address?: string
): [
  tokenIds: [tokenId: number, isClaimed: boolean][] | undefined,
  readFancyBearsClaimStatusByAddress: () => void
] => {
  const [fancyBearsInWallet, setFancyBearsInWallet] =
    useState<[tokenId: number, isClaimed: boolean][]>();

  const [
    { data: fancyBearsClaimStatusByAddressData },
    readFancyBearsClaimStatusByAddress,
  ] = useContractRead(
    {
      addressOrName: honeyJarsContract.address,
      contractInterface: honeyJarsContract.interface,
    },
    "fancyBearsClaimStatusByAddress",
    {
      args: address,
    }
  );

  useEffect(() => {
    if (fancyBearsClaimStatusByAddressData) {
      const bearsStatuses: boolean[] = fancyBearsClaimStatusByAddressData[0];
      const bearsIds: BigNumber[] = fancyBearsClaimStatusByAddressData[1];

      setFancyBearsInWallet(
        bearsIds?.map((bn, index) => [bn.toNumber(), bearsStatuses[index]])
      );
    }
  }, [fancyBearsClaimStatusByAddressData]);

  return useMemo(
    () => [fancyBearsInWallet, readFancyBearsClaimStatusByAddress],
    [fancyBearsInWallet, readFancyBearsClaimStatusByAddress]
  );
};

export default useFancyBearsInWallet;
